import { Divider, Flex, GoodsCarouselSkeleton } from '@banhala/ui-kit';
import { CodiGoodsCarousel } from './CodiGoodsCarousel';
import { MidRelatedRecommendAdGoodsCarousel } from './MidRelatedRecommendAdGoodsCarousel';
import { useCodiGoodsList } from './queries/useCodiGoodsList';
import { useMidRelatedRecommendGoodsList } from './queries/useMidRelatedRecommendGoodsList';
const CarouselDivider = () => <Divider size={'small'} />;

export const GoodsCarouselContent = () => {
  const { data: codiGoods, isLoading: loadingCodiGoods } = useCodiGoodsList();
  const { data: midRelatedRecommend, isLoading: loadingMidRelatedRecommend } =
    useMidRelatedRecommendGoodsList();

  if (loadingCodiGoods || loadingMidRelatedRecommend) {
    return (
      <Flex>
        <Flex.Row
          padding={{ horizontal: 16, vertical: 16 }}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <Flex
            backgroundColor={'bg_tertiary'}
            width={98}
            height={24}
            borderRadius={4}
          ></Flex>
          <Flex
            backgroundColor={'bg_tertiary'}
            width={64}
            height={18}
            borderRadius={4}
          ></Flex>
        </Flex.Row>
        <GoodsCarouselSkeleton count={4} />
      </Flex>
    );
  }

  const hasCodi = (codiGoods?.codi_goods?.item_list ?? []).length > 0;
  const hasMidAd = (midRelatedRecommend?.item_list ?? []).length > 0;

  if (!hasCodi && !hasMidAd) return null;

  return (
    <Flex>
      {hasCodi && <CodiGoodsCarousel />}
      {hasCodi && hasMidAd && <Divider size={'small'} />}
      {hasMidAd && <MidRelatedRecommendAdGoodsCarousel />}
      <Divider size={'medium'} />
    </Flex>
  );
};

export const GoodsCarousel = () => {
  return (
    <Flex>
      <GoodsCarouselContent />
      <CarouselDivider />
    </Flex>
  );
};
